var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRight3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 95,
    height: 66,
    viewBox: "0 0 95 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_918",
    "data-name": "Rectangle 918",
    width: 95,
    height: 66,
    transform: "translate(-0.241 0.036)",
    fill: "#5763f3"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1626",
    "data-name": "Group 1626",
    transform: "translate(-0.055 -0.023)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1606",
    "data-name": "Group 1606",
    transform: "translate(0.296 -0.013)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2499",
    "data-name": "Path 2499",
    d: "M94.058,8.645a1.651,1.651,0,0,0-1.414-.786H64.655a23.546,23.546,0,0,0-35.117,0H1.493A1.2,1.2,0,0,0,.236,8.8a1.427,1.427,0,0,0,0,1.571L6.522,19.8l5.912,8.868a1.407,1.407,0,0,0,.217.561A23.216,23.216,0,0,0,23.2,37.64l-5.68,19.409a3.247,3.247,0,0,0,5.029,3.457l7.229-5.186a1.935,1.935,0,0,1,1.572-.314,1.9,1.9,0,0,1,1.1,1.1l2.986,7.7a3.206,3.206,0,0,0,3.143,2.2h.157a3.548,3.548,0,0,0,3.143-2.514L46.7,47.143c.123,0,.246,0,.369,0s.217,0,.326,0l4.86,16.348A3.5,3.5,0,0,0,55.4,66.007h.157a3.348,3.348,0,0,0,3.143-2.2l2.986-7.7a1.552,1.552,0,0,1,1.1-1.1,1.827,1.827,0,0,1,1.572.314l7.229,5.343a3.247,3.247,0,0,0,5.029-3.457l-5.8-19.831a22.426,22.426,0,0,0,10.275-7.884c.134-.082.267-.17.4-.259L87.771,19.8a1.388,1.388,0,0,0,.191-.444l6.1-9.143a1.426,1.426,0,0,0,0-1.572M27.109,11a22.686,22.686,0,0,0-2.829,6.286H8.565L4.479,11Zm-3.457,9.429a22.14,22.14,0,0,0-.157,3.143,22.141,22.141,0,0,0,.157,3.143h-8.8l-4.086-6.286H23.652Zm-6.286,9.429H24.34q.26.948.6,1.862l-.815,2.784a19.28,19.28,0,0,1-6.755-4.646M38.9,62.706c-.157,0-.157.157-.314.157a.55.55,0,0,1-.314-.157l-2.986-7.7a4.6,4.6,0,0,0-3.143-2.986,4.355,4.355,0,0,0-1.414-.157,5.07,5.07,0,0,0-2.829.943l-7.229,5.186,6.413-21.9a23.535,23.535,0,0,0,16.514,10.8Zm27.345-9.9A4.638,4.638,0,0,0,62,52.02a5.344,5.344,0,0,0-3.143,2.986l-2.986,7.7s0,.157-.314.157-.314-.157-.314-.157l-4.7-15.813A23.536,23.536,0,0,0,67.054,36.1l.288.991c.009.028.021.054.032.081l6.1,20.82Zm3.734-18.281-.8-2.733q.351-.947.621-1.931h6.974a19.3,19.3,0,0,1-6.8,4.664m9.416-7.964H70.5a23.118,23.118,0,0,0,.137-2.986,21.07,21.07,0,0,0-.157-3.143H83.529Zm6.18-9.272H69.856A22.684,22.684,0,0,0,67.027,11H89.815ZM46.955,28.243l-4.967,8.636H33.946l9.155-12.9L34.576,11.305h7.783l4.818,8.525,5.189-8.525h7.672L51.106,23.87l9.006,13.009H52.329Z",
    transform: "translate(-0.347 0.032)",
    fill: "#5763f3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight3);
export default __webpack_public_path__ + "static/media/right_3.e69edee3fe74ad17355d95da73124815.svg";
export { ForwardRef as ReactComponent };